module.exports = __webpack_public_path__ + "img/box-type.3b386259.svg";